import { isTenantThemeDataAvailable } from './isTenantThemeDataAvailable';
import { isOpx } from 'owa-opx';

export function shouldUseCobranding(themeId: string, isDarkTheme: boolean): boolean {
    return themeId === 'base' && !isDarkTheme && isTenantThemeDataAvailable() && !isOpx();
}
